import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    data: []
};
export var MakerCreatorReducer = createSlice({
    name: 'makerCreators',
    initialState: initialState,
    reducers: {
        init: function init(state, reports) {
            state.data = reports.payload;
        },
        add: function add(state, report) {
            var algorithm = {
                name: report.payload.name || '',
                id: 0
            };
            state.data.push(algorithm);
        }
    }
});
var _MakerCreatorReducer$ = MakerCreatorReducer.actions, add = _MakerCreatorReducer$.add, init = _MakerCreatorReducer$.init;
export { add, init };
export default MakerCreatorReducer.reducer;
